import * as React from 'react'
import { Button } from 'react-bootstrap'
import IosArrowBack from 'react-ionicons/lib/IosArrowBack'
import IosArrowForward from 'react-ionicons/lib/IosArrowForward'
import { Checkbox, FormControlLabel } from '@mui/material'

import ButtonLoading from '../../components/ButtonLoading/ButtonLoading'
import CustomerMoveSheetAgreement from '../../components/Agreements/CustomerMoveSheetAgreement'
import config from '../../constants/config'
import { LocationT } from '../../types/Job'
import { FieldsCreateJobT } from './Booking'
import { AxiosInstance } from '../../utils/RequestMethods'
import { CompanyT } from '../../types/Company'


const styles = {
    left: {
        marginLeft: 0
    }
}

interface ScreenAgreementProps {
    handle? : string
    company: CompanyT
    tokenUser : string
    fieldsCreateJob : FieldsCreateJobT
    nextScreen() : void
    goBack() : void
}


const ScreenAgreement : React.FC<ScreenAgreementProps> = (props) : JSX.Element => {

    const [processing, setProcessing] = React.useState<boolean>(false)
    const [iAgree, setIAgree] = React.useState(false);

    const createNewJob = async ( fields : FieldsCreateJobT): Promise<string> => {
      setProcessing(true)
      let params = {
        ...fields, ...{
          handle: props.handle
        }
      }

      let options = {
        headers: {
           'Authorization': `Bearer ${props.tokenUser}`
        }
    }
      return await AxiosInstance.post(`${config.url.jobs}/moving-inquiry/${props.company.id}`,params, options).then((res) => {
          setProcessing(false)
          if (res && res.data) {

              setTimeout(() => {
                  props.nextScreen()
              }, 1000);
              return 'Job created.'
          }
      }).catch((error) => {
          setProcessing(false)
          throw error;
      })

  }


    return (
        <div>
            {/* Scrollable agreement text */}
            <div style={{
                maxHeight: '40vh',
                minHeight: 180,
                overflowY: 'auto',
                border: '1px solid #dee2e6',
                borderRadius: 6,
                padding: '12px 14px',
                backgroundColor: '#f8f9fa',
                marginBottom: 12,
            }}>
                <CustomerMoveSheetAgreement />
            </div>

            {/* I Agree checkbox — always visible outside the scroll area */}
            <FormControlLabel
                label="I agree to the Terms above."
                checked={iAgree}
                onChange={() => setIAgree(!iAgree)}
                control={<Checkbox color="success" />}
            />

            {/* Action buttons — responsive flex layout */}
            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 8,
            }}>
                <Button
                    style={{ minWidth: 100 }}
                    onClick={() => { props.goBack() }}
                    variant="success">
                    <IosArrowBack color="white" />
                    Back
                </Button>
                <ButtonLoading
                    disabled={!iAgree}
                    style={{ minWidth: 100 }}
                    timeShowMsg={0}
                    type="submit"
                    onClickFetching={async (e): Promise<string> => {
                        e.preventDefault();
                        e.stopPropagation()
                        return await createNewJob(props.fieldsCreateJob)
                    }}
                    variant="success">
                    Next
                    <IosArrowForward color="white" />
                </ButtonLoading>
            </div>
        </div>
    )
}


export default ScreenAgreement
